import type { PlayerData, PlayersTableColumns } from '@library/types/player';
import type { TableColumn } from '@library/types/utils';

export const PLAYERS_TABLE_HEADER: Array<TableColumn<PlayersTableColumns>> = [
  {
    column: 'checkbox',
    essential: true,
    label: '',
    sortEnabled: false,
    width: 'w-[3%] px-3'
  },
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: true,
    width: 'w-[10%] px-3'
  },
  {
    column: 'image_url',
    essential: true,
    label: 'Image',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: true,
    width: 'w-[20%] px-3'
  },
  {
    column: 'position',
    essential: true,
    label: 'Position',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'team',
    essential: true,
    label: 'Team',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created At',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'updated_at',
    essential: true,
    label: 'Updated At',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'sportsradar_id',
    essential: true,
    label: 'Sportsradar',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'league.name',
    essential: true,
    label: 'League',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'team_name',
    essential: true,
    label: 'Team Name',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'market',
    essential: true,
    label: 'Market',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  }
];

export const DEFAULT_PLAYER_DATA: PlayerData = {
  combo: '',
  createdAt: '',
  displayName: '',
  fantasyDataId: '',
  id: '',
  imageUrl: '',
  leagueId: '',
  leagueName: '',
  market: '',
  name: '',
  oddsjamId: '',
  oldLeague: '',
  position: '',
  sportsradarId: '',
  statAverages: '',
  swishId: '',
  team: '',
  teamData: '',
  teamName: '',
  updatedAt: ''
};
